const getDriveMetrics = state => state?.drives?.drivesMetrics
const getDriveRoleMetrics = state => state?.drives?.driveRolesMetrics
const getRoleMetrics = state => state?.drives?.roleMetrics
const getDriveData = state => state?.drives?.driveData
const getInterViewerList = state => state?.drives?.interViewerList
const getDriveInterViewerList = state => state?.drives?.driveInterViewerList
const getDegreeList = state => state?.drives?.degreeList
const getCollegeList = state => state?.drives?.collegeList
const getCandidateInterviewDetails = state =>
  state?.drives?.candidateInterviewDetails
const getGroupList = state => state?.drives?.groupList
const getGroupCandidateList = state => state?.drives?.groupCandidateList
const getCityList = state => state?.drives?.cityList
const getCandidateDocumentsList = state => state?.drives?.canditateDocumentList
const getCandidateDocumentsMetrices = state =>
  state?.drives?.canditateDocumentMetrices
const getFreshersList = state => state?.drives?.setNewDriveFreshersList
const getNewDriveStatus = state => state?.drives?.setNewDriveStatus
const getNewDriveScore = state => state?.drives?.setNewDriveScore
const getNewDriveMetrics = state => state?.drives?.updatedStatus
const getRoundData = state => state?.drives?.roundData
const updatedRoundData = state => state?.drives?.updateRoundData
const getStatusList = state => state?.drives?.statusList
const selectors = {
  getNewDriveMetrics,
  getNewDriveStatus,
  getDriveMetrics,
  getDriveRoleMetrics,
  getRoleMetrics,
  getDriveData,
  getInterViewerList,
  getDriveInterViewerList,
  getDegreeList,
  getCollegeList,
  getCandidateInterviewDetails,
  getGroupList,
  getGroupCandidateList,
  getCityList,
  getCandidateDocumentsList,
  getCandidateDocumentsMetrices,
  getFreshersList,
  getNewDriveScore,
  getRoundData,
  updatedRoundData,
  getStatusList
}

export default selectors
